import axios from 'axios'
import qs from 'qs'
import { WWWURL, BXEVN } from './default.js'

const refreshInstance = axios.create({
  baseURL: WWWURL[BXEVN],
  timeout: 10000
})

let refreshPromise = null

function getStoredTokens () {
  return {
    ptoken: localStorage.getItem('PToken') || '',
    refreshToken: localStorage.getItem('PRefreshToken') || ''
  }
}

function requestNewPtoken () {
  const tokens = getStoredTokens()

  // 兼容升级前已经登录的用户：没有 PRefreshToken 时继续使用原 LiveUrl 流程。
  if (!tokens.ptoken || !tokens.refreshToken) {
    return Promise.resolve({
      skipped: true,
      ptoken: tokens.ptoken,
      refreshToken: tokens.refreshToken
    })
  }

  return refreshInstance.post(
    '/surrogates/passport/user/refresh',
    qs.stringify({
      token: tokens.ptoken,
      refreshToken: tokens.refreshToken
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  ).then(function (response) {
    const data = response && response.data ? response.data : {}
    const body = data.body || {}
    const nextPtoken = body.ptoken
    const nextRefreshToken = body.refreshToken

    if (!nextPtoken || !nextRefreshToken) {
      throw new Error(data.Message || data.message || '更新登录信息失败，请重新登录')
    }

    localStorage.setItem('PToken', nextPtoken)
    localStorage.setItem('PRefreshToken', nextRefreshToken)

    return {
      skipped: false,
      ptoken: nextPtoken,
      refreshToken: nextRefreshToken
    }
  })
}

/**
 * 调用 LiveUrl 前刷新 PToken；同一页面的并发调用复用一个刷新请求。
 */
export function refreshPtoken () {
  if (refreshPromise) {
    return refreshPromise
  }

  refreshPromise = requestNewPtoken().then(function (result) {
    refreshPromise = null
    return result
  }, function (error) {
    refreshPromise = null
    throw error
  })

  return refreshPromise
}

export default refreshPtoken



//////////////////
// WEBPACK FOOTER
// /resource/code/pmn3myn9-dev_guanwang_1.5.422/packages/gaosiweb-common/js/ptoken.js
// module id = null
// module chunks = 